import { type ReactElement } from 'react'

import invariant from 'tiny-invariant'

import { config } from '../../../../../../config'
import { LEGAL_INFO, RESTRICTED_JURISDICTIONS } from './contants'

export function getLegalInfoComponent(): () => ReactElement {
  const component = LEGAL_INFO[config.whitelabel]

  invariant(component, `No legal info for ${config.whitelabel}`)

  return component
}

export function getRestrictedJurisdictionsComponent(): () => ReactElement {
  const component = RESTRICTED_JURISDICTIONS[config.whitelabel]

  invariant(component, `No restricted jurisdictions for ${config.whitelabel}`)

  return component
}
